<div class="navbar">
  <div class="top_menu">
    <ng-container *ngFor="let item of navigation">
      <ng-container *ngIf="item.meta.position != 'bottom'">
        <div class="item" *ngIf="item.children.data.length == 0">
          <ng-container *ngIf="item.title == 'Home'">
            <span (click)="goToHomeLink(item.url)" style="color: white">
              <fa-icon
                *ngIf="getNavigationIcon(item.meta.icon) as icon"
                [icon]="icon"
                title="{{ item.title || item.meta.short_title }}"
                [flip]="item.meta.flip_icon"
              ></fa-icon>

              <span class="itemText">{{
                item.meta.short_title || item.title
              }}</span>
            </span>
          </ng-container>
          <ng-container *ngIf="item.title != 'Home'">
            <a
              href="{{ item.url }}"
              target="{{ item.meta.target }}"
              style="color: white"
            >
              <fa-icon
                *ngIf="getNavigationIcon(item.meta.icon) as icon"
                [icon]="icon"
                title="{{ item.title || item.meta.short_title }}"
                [flip]="item.meta.flip_icon"
              ></fa-icon>

              <span class="itemText">{{
                item.meta.short_title || item.title
              }}</span>
            </a>
          </ng-container>
        </div>
        <ng-container *ngIf="item.children.data.length >= 1">
          <app-auto-open-menu [size]="item.children.data.length">
            <div class="item" trigger *ngIf="item.children.data">
              <fa-icon
                *ngIf="getNavigationIcon(item.meta.icon) as icon"
                [icon]="icon"
              ></fa-icon>

              <span class="itemText">{{
                item.meta.short_title || item.title
              }}</span>
            </div>

            <div content>
              <ng-container *ngFor="let menuItem of item.children.data">
                <a
                  mat-menu-item
                  href="{{ generateLink(menuItem.url, menuItem.meta.target) }}"
                  target="{{ menuItem.meta.target }}"
                  title="{{ menuItem.title || menuItem.meta.short_title }}"
                  *ngIf="!localLink(menuItem.url)"
                  >{{ menuItem.meta.short_title || menuItem.title }}
                  <fa-icon [icon]="faStars" *ngIf="menuItem.meta.icon"></fa-icon
                ></a>

                <a
                  mat-menu-item
                  [routerLink]="
                    generateLink(menuItem.url, menuItem.meta.target)
                  "
                  *ngIf="localLink(menuItem.url)"
                  title="{{ menuItem.title || menuItem.meta.short_title }}"
                  >{{ menuItem.meta.short_title || menuItem.title }}
                  <fa-icon [icon]="faStars" *ngIf="menuItem.meta.icon"></fa-icon
                ></a>
              </ng-container>
            </div>
          </app-auto-open-menu>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
